import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlassSVG } from "../../assets";
import {
  GatewayScore,
  Price,
  ProjectConfig,
  Volume,
} from "../../pages/AIAnalyticsDashboard/types";

export interface AllProjects {
  project: ProjectConfig;
  volume: Volume;
  price: Price;
  gatewayScore: GatewayScore;
}

interface SearchbarProps {
  value: string;
  onChange: (value: string) => void;
  data: AllProjects[];
}

export const Searchbar = ({ value, onChange, data }: SearchbarProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [filteredData, setFilteredData] = useState<AllProjects[]>(data);
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setFilteredData(
      data?.filter((item) =>
        item.project.name.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  }, [value, data]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative max-w-[500px] w-full" ref={dropdownRef}>
      <div
        className="flex items-center bg-[#55A6FB] bg-opacity-10 text-gray-400 rounded-lg px-4 py-2 w-full cursor-pointer"
        onClick={() => setIsVisible(true)}
      >
        <MagnifyingGlassSVG className="w-5 h-5 fill-[#007DFF]" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search"
          className="bg-transparent flex-1 text-sm outline-none text-white placeholder:text-opacity-50 ml-2"
        />
      </div>

      {isVisible && (
        <div className="absolute max-h-[300px] overflow-y-auto w-full mt-2 bg-[#09131d] rounded-xl border border-[#55A6FB1A] border-solid border-1 p-2 z-10">
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <div
                key={item.project.id}
                onClick={() => {
                  navigate(`/report/${item.project.id}`);
                  setIsVisible(false);
                }}
                className="flex items-center gap-2 p-3 hover:bg-[#55A6FB1A] rounded-lg cursor-pointer"
              >
                <img
                  src={`https://mygateway.io/assets/img/tokens/${item.project.symbol}.webp`}
                  className="w-8 h-8 rounded-full"
                  alt="project"
                />
                <div className="flex gap-1">
                  <span>{item.project.name}</span>
                  <span className="text-[#FFFFFF88]">
                    {item.project.symbol}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-2 text-white opacity-50">
              No projects found
            </div>
          )}
        </div>
      )}
    </div>
  );
};
